import "core-js/modules/es6.object.assign";
import { isFieldDef, vgField } from '../../channeldef';
import { GEOJSON } from '../../type';
import * as encode from './encode';
export var geoshape = {
  vgMark: 'shape',
  encodeEntry: function encodeEntry(model) {
    return Object.assign({}, encode.baseEncodeEntry(model, {
      align: 'ignore',
      baseline: 'ignore',
      color: 'include',
      size: 'ignore',
      orient: 'ignore'
    }));
  },
  postEncodingTransform: function postEncodingTransform(model) {
    var encoding = model.encoding;
    var shapeDef = encoding.shape;
    var transform = Object.assign({
      type: 'geoshape',
      projection: model.projectionName()
    }, shapeDef && isFieldDef(shapeDef) && shapeDef.type === GEOJSON ? {
      field: vgField(shapeDef, {
        expr: 'datum'
      })
    } : {});
    return [transform];
  }
};